import React from 'react'
// view components
import { TableRow } from '@mui/material'
import { HoverablePopover, Link } from 'components/UI'
// components
import PlanActionsMenu from './components/PlanActionMenu'
// views
import { EllipsizedText } from 'themes/views/generic'
import { Chip, ReviewIcon, TableCell } from 'themes/views/tables'
// types
import { IPlan } from 'types/graphql'
// utils
import pipe from 'lodash/fp/pipe'
import filter from 'lodash/fp/filter'
import { getEntityStatus } from 'utils/fields'
import { getChipColor, getClosestReview, getOwnedBy, safeGetOr } from 'utils'

interface Props {
  data: IPlan
}

const Row: React.FC<Props> = ({ data }) => {
  const { id, companyId, name, planType, ownedByUser, ownedByPosition, parentPlanId } = data

  const closestReview = getClosestReview(data)
  const ownedBy = getOwnedBy(ownedByPosition, ownedByUser)

  const fieldValues = pipe(
    safeGetOr<IPlan, 'fieldValueMap', []>([], 'fieldValueMap'),
    filter((value: any) => value.entityId === data.planType.id)
  )(data)

  return (
    <TableRow hover>
      <TableCell size={30} withEllipsis>
        <HoverablePopover
          trigger={
            <span>
              <Link
                href={{
                  pathname: `/plans/${companyId}/edit/${id}`,
                  query: {
                    ...(parentPlanId && { parentId: parentPlanId })
                  }
                }}>
                <EllipsizedText>{name}</EllipsizedText>
              </Link>
            </span>
          }>
          {name}
        </HoverablePopover>
      </TableCell>
      <TableCell size={10}>{getEntityStatus(fieldValues, data.planType.fields) || 'N/A'}</TableCell>
      <TableCell size={25}>{planType?.description}</TableCell>
      <TableCell size={5}>
        <Chip
          rounded
          icon={closestReview ? <ReviewIcon /> : null}
          chipColor={getChipColor(closestReview?.dueDate, closestReview?.status)}
          label={closestReview ? closestReview.dueDate.format('D MMM YY') : 'No review'}
        />
      </TableCell>
      <TableCell size={25}>{ownedBy}</TableCell>
      <PlanActionsMenu data={data} />
    </TableRow>
  )
}

export default Row
